/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PaymentDto, TosspaymentApprovalDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PaymentService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 결제 승인요청
   *
   * @tags PaymentService
   * @name ApproveTosspay
   * @summary 결제 승인요청
   * @request POST:/v1/payments
   * @secure
   */
  approveTosspay = (data: TosspaymentApprovalDto, params: RequestParams = {}) =>
    this.http.request<PaymentDto, any>({
      path: `/v1/payments`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
